import moment from 'moment'
import {GENDER_MALE} from '@/consts'
import { format, validate } from '@/helpers/rut'
import contractStatuses from '@/components/Helpers/Constants/contract.js'
import budgetStatuses from '@/components/Helpers/Constants/budget.js'

const filters = {
	// toThousandFilter(num, decimal = 0) {
  //   const [integer, decimalPart] = ((+num || 0).toString()).split('.');
  //   let formatted = integer.replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, '.'));

  //   if (decimal !== 0) {
	// 		const formattedDecimal = decimalPart ? decimalPart.slice(0, decimal) : '';
	// 		formatted += ',' + formattedDecimal.padEnd(decimal, '0');
  //   }

  //   return formatted;
	// },
	toThousandFilter(num, decimal = 0) {
		const n = Number(num) || 0;
		const rounded = n.toFixed(decimal);
		const safeRounded = /^-0(\.0+)?$/.test(rounded) ? rounded.slice(1) : rounded;
		const [integer, decimalPart] = safeRounded.split('.');

		let formatted = integer.replace(/^-?\d+/g, m =>
			m.replace(/(?=(?!\b)(\d{3})+$)/g, '.')
		);

		if (decimal > 0) {
			formatted += ',' + (decimalPart || '').padEnd(decimal, '0');
		}

		return formatted;
	},
	toDateTime(date) {
		const m = moment(date);
		return m.isValid() ? m.format('DD-MM-YYYY | HH:mm') : '--';
	},
	toDateTimeShort(date) {
		const m = moment(date);
		if (!m.isValid()) return '--';

		const now = moment();

		if (m.isSame(now, 'day')) {
			return m.format('HH:mm');
		} else if (m.isSame(now.clone().subtract(1, 'day'), 'day')) {
			return `Ayer`;
		} else {
			return m.format('DD-MM-YYYY');
		}
	},
	toDateFormat(date) {
		const m = moment(date);
		return m.isValid() ? m.format('DD-MM-YYYY') : '--';
	},
	toDate(date, fromFormat = null, format = 'DD-MM-YYYY') {
		let parsedDate;

		if (fromFormat) {
			parsedDate = moment(date, fromFormat, true);
		} else {
			parsedDate = moment(date);
		}

		return parsedDate.isValid() ? parsedDate.format(format) : '--';
	},
	toHour(date) {
		const m = moment(date);
		return m.isValid() ? m.format('HH:mm') : '--';
	},
	toYear(date) {
		const m = moment(date);
		return m.isValid() ? m.format('YYYY') : '--';
	},
	oneDecimalsNumber(number){
		return Math.round(number * 10) / 10
	},
	formatRut(rut){
		return validate(rut) ? format(rut):rut
	},
	gender(gender){
		return gender == GENDER_MALE ? 'Masculino':'Femenino'
	},
	genderIcon(gender){
		return gender == GENDER_MALE ? 'mdi-gender-male':'mdi-gender-female'
	},
	addTargetsToLinksMessages(message) {
		const container = document.createElement('div');
		container.innerHTML = message;
		const links = container.getElementsByTagName('a');
		for (let i = 0; i < links.length; i++) {
			links[i].setAttribute('target', '_blank');
		}
		return container.innerHTML;
	},
	budgetStatus(status) {
		const statuses = ['Creado','Enviado','Observado','Aceptado','Rechazado','Pagado']
    if (Number.isInteger(status) && status >= 1 && status <= statuses.length) {
        return statuses[status - 1];
    }
		return '--'
	},
	budgetStatusColor(status){
		const statuses = ['#524D4D','warning','warning','green','#FF1209','green']
    if (Number.isInteger(status) && status >= 1 && status <= statuses.length) {
        return statuses[status - 1];
    }
		return '#524D4D'
	},
	contractStatus(status) {
		const statuses = ['Creado', 'Esperando Pago Contrato', 'Contrato Pagado', 'Esperando Visto Bueno Empresa / Profesional', 'Visto Bueno Empresa / Profesional', 'Enviado', 'Observado', 'Aceptado', 'Rechazado', 'Firmado Cliente', 'Firmado Ambas Partes', 'Subcontrato Suspendido']
    if (Number.isInteger(status) && status >= 1 && status <= statuses.length) {
        return statuses[status - 1];
    }
		return '--'
	},
	contractStatusSubcontractor(status) {
		const statuses = ['Creado', 'Esperando Pago Contrato', 'Contrato Pagado', 'Esperando Visto Bueno Empresa / Profesional', 'Visto Bueno Empresa / Profesional', 'Enviado', 'Observado', 'Aceptado', 'Rechazado', 'Firmado Subcontratista', 'Firmado Ambas Partes', 'Subcontrato Suspendido']
    if (Number.isInteger(status) && status >= 1 && status <= statuses.length) {
        return statuses[status - 1];
    }
		return '--'
	},
	contractStatusColor(status){
		const statuses = ['#524D4D','warning','green','#524D4D','#524D4D','green','warning','green','#FF1209','green','green','#FF1209']
    if (Number.isInteger(status) && status >= 1 && status <= statuses.length) {
        return statuses[status - 1];
    }
		return '#524D4D'
	},
	preprojectStatus(status) {
		const statuses = ['En recopilación de antecedentes','Pasó a presupuesto','Pasó a contrato','Rechazado']
    if (Number.isInteger(status) && status >= 1 && status <= statuses.length) {
        return statuses[status - 1];
    }
		return '--'
	},
	preprojectStatusColor(status){
		const statuses = ['#524D4D','warning','green','#FF1209']
    if (Number.isInteger(status) && status >= 1 && status <= statuses.length) {
        return statuses[status - 1];
    }
		return '#524D4D'
	},
	contractEstatusNotice(status){
		if(!status) return ''
		else if(status < contractStatuses.ENVIADO_CONTRAPARTE){
			return 'El cliente aún no puede visualizar el contrato'
		}
		else if(status == contractStatuses.ENVIADO_CONTRAPARTE){
			return 'El contrato ya puede ser visualizado por el cliente'
		}
		else if(status == contractStatuses.OBSERVADO_CONTRAPARTE){
			return 'El cliente ha realizado observaciones, resuélvelas y envíale de nuevo el contrato'
		}
		else if(status == contractStatuses.ACEPTADO){
			return 'El cliente ha aceptado el contrato pero aún no lo ha firmado'
		}
		else if(status == contractStatuses.RECHAZADO){
			return 'El cliente ha rechazado el contrato'
		}
		else if(status == contractStatuses.FIRMADO_CONTRAPARTE){
			return 'El cliente ha firmado el contrato, ahora debe ser firmado por la Empresa / Profesional'
		}
		else if(status == contractStatuses.FIRMADO_AMBAS_PARTES){
			return 'El contrato ha sido firmado por ambas partes'
		}
		return ''
	},
	contractEstatusNoticeClient(status){
		if(!status) return ''
		else if(status < contractStatuses.ENVIADO_CONTRAPARTE){
			return 'El cliente aún no puede visualizar el contrato'
		}
		else if(status == contractStatuses.ENVIADO_CONTRAPARTE){
			return 'El contrato está listo para ser revisado'
		}
		else if(status == contractStatuses.OBSERVADO_CONTRAPARTE){
			return 'La empresa está revisando las observaciones'
		}
		else if(status == contractStatuses.ACEPTADO){
			return 'El contrato ha sido aceptado, ahora deberás firmarlo'
		}
		else if(status == contractStatuses.RECHAZADO){
			return 'El contrato ha sido rechazado, podrán enviarte una nueva revisión'
		}
		else if(status == contractStatuses.FIRMADO_CONTRAPARTE){
			return 'Firmado por cliente, en espera de ser firmado por la empresa / profesional'
		}
		else if(status == contractStatuses.FIRMADO_AMBAS_PARTES){
			return 'El contrato ha sido firmado por ambas partes'
		}
		return ''
	},
	subcontractStatusNotice(status){
		if(!status) return ''
		else if(status < contractStatuses.ENVIADO_CONTRAPARTE){
			return 'El proveedor aún no puede visualizar el subcontrato'
		}
		else if(status == contractStatuses.ENVIADO_CONTRAPARTE){
			return 'El subcontrato ya puede ser visualizado por el proveedor'
		}
		else if(status == contractStatuses.OBSERVADO_CONTRAPARTE){
			return 'El proveedor ha realizado observaciones, resuélvelas y envíale de nuevo el subcontrato'
		}
		else if(status == contractStatuses.ACEPTADO){
			return 'El proveedor ha aceptado el subcontrato pero aún no lo ha firmado'
		}
		else if(status == contractStatuses.RECHAZADO){
			return 'El proveedor ha rechazado el subcontrato'
		}
		else if(status == contractStatuses.FIRMADO_CONTRAPARTE){
			return 'El proveedor ha firmado el subcontrato, ahora debe ser firmado por la Empresa / Profesional'
		}
		else if(status == contractStatuses.FIRMADO_AMBAS_PARTES){
			return 'El subcontrato ha sido firmado por ambas partes'
		}
		else if(status == contractStatuses.SUBCONTRATO_ANULADO){
			return 'El subcontrato ha sido anulado'
		}
		return ''
	},
	subcontractStatusNoticeContractor(status){
		if(!status) return ''
		else if(status < contractStatuses.ENVIADO_CONTRAPARTE){
			return 'El proveedor aún no puede visualizar el contrato'
		}
		else if(status == contractStatuses.ENVIADO_CONTRAPARTE){
			return 'El contrato está listo para ser revisado'
		}
		else if(status == contractStatuses.OBSERVADO_CONTRAPARTE){
			return 'La empresa está revisando las observaciones'
		}
		else if(status == contractStatuses.ACEPTADO){
			return 'El contrato ha sido aceptado, ahora deberás firmarlo'
		}
		else if(status == contractStatuses.RECHAZADO){
			return 'El contrato ha sido rechazado, podrán enviarte una nueva revisión'
		}
		else if(status == contractStatuses.FIRMADO_CONTRAPARTE){
			return 'Firmado por proveedor, en espera de ser firmado por la empresa / profesional'
		}
		else if(status == contractStatuses.FIRMADO_AMBAS_PARTES){
			return 'El contrato ha sido firmado por ambas partes'
		}
		return ''
	},
	addendumStatusNotice(status){
		if(!status) return ''
		else if(status < contractStatuses.ENVIADO_CONTRAPARTE){
			return 'El cliente aún no puede visualizar el anexo'
		}
		else if(status == contractStatuses.ENVIADO_CONTRAPARTE){
			return 'El anexo ya puede ser visualizado por el cliente'
		}
		else if(status == contractStatuses.OBSERVADO_CONTRAPARTE){
			return 'El cliente ha realizado observaciones, resuélvelas y envíale de nuevo el anexo'
		}
		else if(status == contractStatuses.ACEPTADO){
			return 'El cliente ha aceptado el anexo pero aún no lo ha firmado'
		}
		else if(status == contractStatuses.RECHAZADO){
			return 'El cliente ha rechazado el anexo'
		}
		else if(status == contractStatuses.FIRMADO_CONTRAPARTE){
			return 'El cliente ha firmado el anexo, ahora debe ser firmado por la Empresa / Profesional'
		}
		else if(status == contractStatuses.FIRMADO_AMBAS_PARTES){
			return 'El anexo ha sido firmado por ambas partes'
		}
		return ''
	},
	addendumStatusNoticeClient(status){
		if(!status) return ''
		else if(status < contractStatuses.ENVIADO_CONTRAPARTE){
			return 'El cliente aún no puede visualizar el anexo'
		}
		else if(status == contractStatuses.ENVIADO_CONTRAPARTE){
			return 'El anexo está listo para ser revisado'
		}
		else if(status == contractStatuses.OBSERVADO_CONTRAPARTE){
			return 'La empresa está revisando las observaciones'
		}
		else if(status == contractStatuses.ACEPTADO){
			return 'El anexo ha sido aceptado, ahora deberás firmarlo'
		}
		else if(status == contractStatuses.RECHAZADO){
			return 'El anexo ha sido rechazado, podrán enviarte una nueva revisión'
		}
		else if(status == contractStatuses.FIRMADO_CONTRAPARTE){
			return 'Firmado por cliente, en espera de ser firmado por la empresa / profesional'
		}
		else if(status == contractStatuses.FIRMADO_AMBAS_PARTES){
			return 'El anexo ha sido firmado por ambas partes'
		}
		return ''
	},
	budgetEstatusNotice(status){
		if(!status) return ''
		else if(status < budgetStatuses.ENVIADO_CONTRAPARTE){
			return 'El cliente aún no puede visualizar el presupuesto'
		}
		else if(status == budgetStatuses.ENVIADO_CONTRAPARTE){
			return 'El presupuesto ya puede ser visualizado por el cliente'
		}
		else if(status == budgetStatuses.OBSERVADO_CONTRAPARTE){
			return 'El cliente ha hecho una observación al presupuesto'
		}
		else if(status == budgetStatuses.ACEPTADO){
			return 'El cliente ha aceptado el presupuesto'
		}
		else if(status == budgetStatuses.RECHAZADO){
			return 'El cliente ha aceptado el presupuesto'
		}
		return ''
	},
	budgetEstatusNoticeClient(status){
		if(!status) return ''
		else if(status < budgetStatuses.ENVIADO_CONTRAPARTE){
			return 'El cliente aún no puede visualizar el presupuesto'
		}
		else if(status == budgetStatuses.ENVIADO_CONTRAPARTE){
			return 'El presupuesto está listo para ser revisado'
		}
		else if(status == budgetStatuses.OBSERVADO_CONTRAPARTE){
			return 'El cliente ha hecho una observación al presupuesto'
		}
		else if(status == budgetStatuses.ACEPTADO){
			return 'El presupuesto ha sido aceptado'
		}
		else if(status == budgetStatuses.RECHAZADO){
			return 'El presupuesto ha sido rechazado, podrán enviarte una nueva revisión'
		}
		return ''
	},
}

export default filters